var _defs, _rect, _rect2, _circle, _circle2, _circle3, _polyline, _rect3, _polyline2, _rect4, _polyline3, _line, _line2, _line3, _polyline4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.71 130.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#17ff39;}.c{fill:#f8ff2e;}.d{fill:#f70006;}.e,.f,.g{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:7px;}.e,.g{stroke-linecap:round;}.g{opacity:0.7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo main") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 152.71,
    height: 130.89,
    rx: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 12.94,
    y: 20.01,
    width: 126.82,
    height: 97.86,
    rx: 7.44
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 48.11,
    cy: 10.69,
    r: 5.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 33.06,
    cy: 10.69,
    r: 5.03
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 18.01,
    cy: 10.69,
    r: 5.03
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "99.58 60.7 82.09 60.7 82.09 69.45 99.58 69.45 99.58 78.19 82.09 78.19"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 53.26,
    y: 60.7,
    width: 17.49,
    height: 17.49
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "24.63 78.19 24.63 60.7 42.12 60.7 42.12 78.19"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 111.1,
    y: 32.15,
    width: 17.49,
    height: 17.49
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "82.09 49.64 82.09 32.15 99.58 32.15"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 70.89,
    y1: 32.15,
    x2: 70.89,
    y2: 49.64
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 53.4,
    y1: 49.64,
    x2: 53.4,
    y2: 32.15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 70.89,
    y1: 40.9,
    x2: 53.4,
    y2: 40.9
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "42.12 49.64 24.63 49.64 24.63 32.15 42.12 32.15"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 111.1,
    y: 60.7,
    width: 17.49,
    height: 17.49
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 53.33,
    y: 60.7,
    width: 17.49,
    height: 17.49
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 24.63,
    y: 89.25,
    width: 17.49,
    height: 17.49
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 82.09,
    y: 89.25,
    width: 17.49,
    height: 17.49
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 53.33,
    y: 89.25,
    width: 17.49,
    height: 17.49
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.8d35e489.svg";
export { ForwardRef as ReactComponent };